import React, { useState, useRef, useEffect } from 'react'
import { Divider } from 'antd-mobile'
import { PageLoading } from '@/components/Loading'
import SettingResult from './components/SettingResult'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'


// 升级状态列表
const UPGRADE_STATUS_LIST: {[key: string]: string} = {
  'UPGRADING': 'bmsFirmware.statusUpgrading', // 升级中
  'SUCCESS': 'bmsFirmware.statusSUCCESS', // 升级完成
  'FAILED': 'bmsFirmware.statusFailed' // 升级失败
}

const OtaUpdateProgess = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const upgradeFirmewareStatus = useSelector((state: any) => state.globalData.upgradeFirmewareStatus)

  const [showLoading, setShowLoading] = useState<{ text: any; isShow: boolean }>({ text: '', isShow: false })
  const [resultConfig, setResultConfig] = useState({
    show: false,
    status: 'success' as 'success' | 'error',
    title: '',
    subTitle: ''
  })

  const hideLoading = () => {
    setShowLoading({ text: '', isShow: false })
  }

  useEffect(() => {
    if (upgradeFirmewareStatus) {
        switch(upgradeFirmewareStatus.status) {
            case 'SUCCESS': 
                hideLoading()
                // 显示成功结果
                setResultConfig({
                  show: true,
                  status: 'success',
                  title: t('bmsFirmware.upgradeSuccess'), // 升级成功
                  subTitle: t('bmsFirmware.upgradeSuccessSubtitle') // BMS固件升级完成！
                })
                dispatch({ type: 'Hems.setting/saveUpgradeFirmewareStatus', payload: null })
            case 'FAILED':
                hideLoading()
                setResultConfig({
                    show: true,
                    status: 'error',
                    title: t('bmsFirmware.upgradeFailed'), // 升级失败
                    subTitle: t('bmsFirmware.upgradeFailedCheckDevice') // 请检查设备状态，并重新尝试升级
                })
              dispatch({ type: 'Hems.setting/saveUpgradeFirmewareStatus', payload: null })
            case 'UPGRADING':
                const upgradeDetails = (
                    <>
                      <div>
                        {t('bmsFirmware.deviceUpgrading')}
                        {/* {t('bmsFirmware.deviceUpgrading').replace('{deviceSn}', upgradeFirmewareStatus?.deviceSn || '')}  */}
                        {/* 正在升级固件包, 升级时间在30 ~ 50 分钟，期间无法查看设备实时数据，请等待... */}
                      </div>
                      <Divider />
                      
                    <div style={{ marginTop: '.1rem', fontSize: '.26rem', textAlign: 'left', lineHeight: '1.5' }}>
                        <div>{t('menu.device')}: {upgradeFirmewareStatus?.deviceSn || '- -'}</div>  
                        <div>
                        {t('bmsFirmware.upgradeStatusLabel')}：{/* 升级状态 */}
                        {upgradeFirmewareStatus?.status && UPGRADE_STATUS_LIST[upgradeFirmewareStatus.status] 
                            ? t(UPGRADE_STATUS_LIST[upgradeFirmewareStatus.status])
                            : ''}
                        </div>
                        <div>
                        {t('bmsFirmware.upgradeProgressLabel')}：{/* 升级进度 */}
                          <strong style={{ fontSize: '.34rem', color: '#0dbc0d' }}>{upgradeFirmewareStatus?.progress || 0}%</strong>
                        </div>
                        <div>
                        {t('bmsFirmware.currentPackageLabel')}：{/* 当前已传输的数据包序号 */}
                        {upgradeFirmewareStatus?.currentPackage || 0}
                        </div>
                        <div>
                        {t('bmsFirmware.totalPackagesLabel')}：{/* 总数据包数量 */}
                        {upgradeFirmewareStatus?.totalPackages || 0}
                        </div>
                    </div>
                    </>
                  )
                setShowLoading({ 
                    text: upgradeDetails,
                    isShow: true 
                })
        }

    }
  }, [upgradeFirmewareStatus])

  return (
    <div>
      <PageLoading styleCustom={{ width: '80%'}} text={showLoading.text} isShow={showLoading.isShow} />
      <SettingResult
        open={resultConfig.show}
        onClose={() => setResultConfig(prev => ({ ...prev, show: false }))}
        status={resultConfig.status}
        title={resultConfig.title}
        subTitle={resultConfig.subTitle}
      />
    </div>
  )
}

export default OtaUpdateProgess